<template>
	<div class="overflow-auto">
		<h3
			:class="`${
				type === 'Today' ? 'alert-danger' : ''
			} p-2 text-green fs-4`"
			role="alert"
		>
			{{ type }}
		</h3>
		<table
			v-for="(reminderData, index) in data"
			:key="`today-${index}`"
			:class="`${
				type === 'Today' ? 'alert-danger' : ''
			}`"
			role="alert"
		>
				<tr class="border-info table-background-green">
					<th class="text-gray">
						<b class="text-green">Lead Number</b>
					</th>
					<th class="text-gray">
						<b class="text-green rightpadding">Customer</b>
					</th>
					<th class="text-dar">
						<b class="text-green rightpadding">Date</b>
					</th>
					<th class="text-gray">
						<b class="text-green rightpadding">Time</b>
					</th>
				</tr>
				<tr class="border-bottom border-info">
					<td class="text-gray">{{ reminderData.leadNumber }}</td>
				
					
					<td class="text-gray rightpadding">
						{{ reminderData.name.salutation }}
						{{ reminderData.name.firstName }}
						{{ reminderData.name.lastName }}
					</td>
				
					
					<td class="text-gray rightpadding">
						{{
							new Intl.DateTimeFormat("en-US", {
								timeZone: "Asia/Kolkata",
								dateStyle: "medium",
								timeStyle: "short",
							})
								.format(
									new Date(reminderData.reminder.date.split("T")[0]) -
										new Date(18000000 + 1800000),
								)
								.toString()
								.replace(/([,]\s[1][2][:][0][0])\s\w+/g, "")
						}}
					</td>
				
					
					<td class="text-gray rightpadding">
						{{
							reminderData.reminder.date.split("T")[1] !== "00:00:00.000Z"
								? reminderData.reminder.date
										.split("T")[1]
										.replace(":00.000Z", "")
								: "10:00"
						}}
					</td>
				</tr>

				<!-- <div class="col-2">
					<p class="mb-1"><b>Action</b></p>
					<button
						:class="`${
							type === 'Today' ? 'btn-success' : 'btn-warning'
						} btn btn-sm`"
					>
						<i class="bi bi-envelope text-danger"></i> Send Mail
					</button>
				</div> -->
			
			<div class="d-flex justify-space-between mt-2">
				<h4 class="mb-0 text-green">
					{{ reminderData.reminder.description }}
				</h4>
			</div>
			</table>
	</div>
</template>
<script>
	export default {
		name: "ReminderDetails",
		props: {
			data: { type: Array, required: true },
			type: { type: String, default: "Today" },
		},
	};
</script>
<style scoped>
.table-background-green{
	background: #9fb2652b;
}
.rightpadding{
	padding-right: 5px;
}
</style>

